import { zoomSliderOptions } from '../../workspace/header/currentBoardHeader/view/ZoomPopupPanelSection';

export const getZoomTextInUnits = (value: number): string => `${Math.round(value)}${zoomSliderOptions.unit}`;
